/**
 * Trunnion AI - Dashboard Query Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/config/queryKeys';
import { dashboardApi } from '@/api/dashboard.api';

export function useDashboardOverview() {
  return useQuery({
    queryKey: queryKeys.dashboard.overview(),
    queryFn: () => dashboardApi.getOverview(),
    refetchInterval: 30_000,
  });
}

export function useActiveRuns() {
  return useQuery({
    queryKey: queryKeys.dashboard.activeRuns(),
    queryFn: () => dashboardApi.getActiveRuns(),
    refetchInterval: 5_000,
  });
}

export function useTokenUsageSummary(period?: 'day' | 'week' | 'month') {
  return useQuery({
    queryKey: [...queryKeys.dashboard.all, 'token-usage', period],
    queryFn: () => dashboardApi.getTokenUsageSummary({ period }),
  });
}

export function useRecentAudit(limit?: number) {
  return useQuery({
    queryKey: [...queryKeys.dashboard.all, 'recent-audit', limit],
    queryFn: () => dashboardApi.getRecentAudit(limit),
    refetchInterval: 15_000,
  });
}
